// a react-three-fiber scene
import { softShadows } from "@react-three/drei";

import React, { useMemo, useRef } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import Model from "./Next_plant_v3_final";
import Plane from "./Plane_lemon3";
import { Suspense } from "react";
import { Floor } from "./Scene";
import {
  EffectComposer,
  DepthOfField,
  Vignette,
  Scanline,
  ChromaticAberration,
  Bloom,
} from "@react-three/postprocessing";
import { animated, useSpring } from "@react-spring/three";

softShadows();

export default function Scene7() {
  return (
    <div style={{ height: "100%" }}>
      <Suspense falllback={null}>
        <Canvas
          draggable
          shadows
          camera={{ position: [-50, 25, 0], zoom: 0.8, fov: 35, near: 0.01 }}
        >
          <fog attach="fog" args={["#ddd", 50, 180]} />

          <Suspense falllback={null}>
            <Inner />
            <Floor color={"#777"}></Floor>
            <ambientLight intensity={2}></ambientLight>
          </Suspense>
          <EffectComposer>
            <DepthOfField
              focusDistance={80}
              focalLength={20}
              bokehScale={0.2}
              height={480}
            />
            <Bloom luminanceThreshold={0} luminanceSmoothing={2} height={300} />
            <Scanline opacity={0.05}></Scanline>
            <Vignette eskil={false} offset={0.1} darkness={0.8} />
            <ChromaticAberration></ChromaticAberration>
          </EffectComposer>
        </Canvas>
      </Suspense>
    </div>
  );
}

function Inner() {
  const plane = useRef();
  const sideMover = useRef();
  const [{ sideOffset, rotation }, api] = useSpring(() => ({
    from: { sideOffset: [0, 0, 0], rotation: [0, 0, 0] },
    to: { sideOffset: [0, 0, 0], rotation: [0, 0, 0] },
  }));
  let camOffset = useMemo(() => {
    return 0;
  }, []);
  useFrame(({ camera, mouse }, delta) => {
    let move = delta * 30;
    camera.position.x += move;

    if (camera.position.x / 105 > camOffset) {
      camera.position.x -= 105;
    }
    if (plane.current) {
      plane.current.position.x = camera.position.x + 20;
      //console.log("move plane", plane.current.position.x, camera.position.x);
    }
    if (sideOffset) {
      let currPos = sideMover.current.position.z;
      let target = mouse.x * 6;
      let progress = target - currPos;
      api({ sideOffset: [0, 0, target], rotation: [progress / 5, 0, 0] });
    }
  });
  return (
    <>
      <Model position={[-105, 0, 0]} scale={4}></Model>
      <Model position={[0, 0, 0]} scale={4}></Model>
      <Model position={[105, 0, 0]} scale={4}></Model>
      <animated.group ref={sideMover} position={sideOffset}>
        <group ref={plane} position={[0, 20, 0]}>
          <animated.group rotation={rotation}>
            <Suspense falllback={null}>
              <Plane scale={4} rotation={[0, -Math.PI / 2, 0]}></Plane>
            </Suspense>
          </animated.group>
        </group>
      </animated.group>
    </>
  );
}
